import { BaseObject } from '@gss/types/shared';

export interface DictionaryStatusData<TData extends BaseObject> {
  isFetching?: boolean;
  isFailed?: boolean;
  result?: TData;
}

export enum DictionaryStatuses {
  fetching = 'fetching',
  completed = 'completed',
  failed = 'failed',
}

export interface StoredDictionaryStructure<TData extends BaseObject> {
  status: DictionaryStatuses;
  data?: TData;
}

export interface StateChangeAction<TData extends BaseObject = BaseObject> {
  key: string;
  data?: TData;
  error?: unknown;
}
